/* eslint-disable no-use-before-define */
import React, { memo } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";

const icon = <i className="far fa-square"></i>;
const checkedIcon = <i className="fas fa-check-square"></i>;

const DropdownMultiCheckbox = props => {
  const options = props.setFirstLetter ? props.optionList.map(props.setFirstLetter) : props.optionList.map(option => {
    const firstLetter = (props.render ? props.render(option) : option.title)[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter, ...option
    };
  });

  return (<Autocomplete
    disabled={props.disabled}
    multiple={!!props.isMultiple}
    id="checkboxDrowdown"
    className={"checkbox-dropdown w-100 " + (props.className || " ")}
    disableCloseOnSelect
    onChange={async (_, val) => {
      props.onChange(val || []);
    }}
    defaultValue={props.defaultValue}
    value={props.value || props.defaultValue || []}
    options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
    groupBy={props.disableGrouping ?undefined : option => option.firstLetter }
    getOptionLabel={option => option.title || ''}
    getOptionSelected={(option, value) => {
      return props.render ? props.render(option) === props.render(value) : option.title === value.title;
    }}
    renderOption={(option, { selected }) => (<>
      <Checkbox
        icon={icon}
        className="ic-checkbox"
        checkedIcon={checkedIcon}
        style={{ marginRight: 8 }}
        checked={selected}
      />
      {props.render ? props.render(option) : option.title}
    </>)}
    renderInput={params => (<TextField {...params} placeholder={props.placeholder} />)}
  />);
};

DropdownMultiCheckbox.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  disableGrouping: PropTypes.bool,
  render: PropTypes.func,
  onChange: PropTypes.func.isRequired
};

export default memo(DropdownMultiCheckbox);
